export default __webpack_public_path__ + "static/media/alert-circle-red.d1e226af.svg";